import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';

import { selectIsModalSignInRemindEnabled } from '../../../redux/diagram/diagram.selectors';
import { disableModalSignInRemind } from '../../../redux/diagram/diagram.actions';

import { trackEvent } from '../../../lib/analytics';

import Modal from '../Modal/Modal';
import './ModalSignInReminder.scss';

export const ModalSignInReminder = () => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();

    const isOpen = useSelector(selectIsModalSignInRemindEnabled);

    const handleCancel = () => {
        dispatch(disableModalSignInRemind());
        // sessionStorage.setItem('show-notify', 'true');
    };

    const handleSignIn = () => {
        trackEvent('playground_modal_signin_remind_signin', {
            page: 'playground',
            type: 'modals',
        });
        // setTimeout(() => { window.location.href = 'https://app.dbdesign.io/login'; }, 150);
        setTimeout(() => { window.open('https://app.dbdesign.io/login', '_blank'); }, 150)
    };

    const handleSignUp = () => {
        trackEvent('playground_modal_signin_remind_signup', {
            page: 'playground',
            type: 'modals',
        });
        // setTimeout(() => { window.location.href = 'https://app.dbdesign.io/signup'; }, 150); setTimeout(() => { window.open('https://app.dbdesign.io/login', '_blank'); }, 150)
        setTimeout(() => { window.open('https://app.dbdesign.io/signup', '_blank'); }, 150)
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-sign-in-remind`}
            onCancel={handleCancel}
        >
            <div className="modal-content-header">{t('m_sign_in_remind.title')}</div>
            {/* <div className="modal-content-header">{`Sign in to access this feature`}</div> */}
            {/* <div className="modal-content-header">{`You’ve hit the cap for tables! 🚀`}</div> */}
            <div className="modal-content-body">
                <div className='description-text'>{t('m_sign_in_remind.subtitle')}</div>
                <button className="primary" onClick={() => handleSignIn()}>{t('b.sign_in')}</button>
                <button className="secondary" onClick={() => handleSignUp()}>{t('b.sign_up')}</button>
            </div>
        </Modal>
    );
};

export default ModalSignInReminder;
